import { useState, useEffect, useRef } from "react";
import { db } from "../firebase.js";
import { ref, set, get, onValue, update, push } from "firebase/database";

const TOKENS = ["🎩","🐕","🚂","⚓","🏎️","👞","🎸","🐱","🦆","🏂"];
const COLORS = { brown:"#8B4513", lightblue:"#87CEEB", pink:"#C2185B", orange:"#E65100", red:"#C62828", yellow:"#F9A825", green:"#2E7D32", darkblue:"#1565C0" };
const PLAYER_COLORS = ["#EF4444","#3B82F6","#22C55E","#F59E0B","#8B5CF6","#EC4899"];

const BOARD = [
  {id:0,name:"GO",type:"go"},
  {id:1,name:"Mediterranean Ave",type:"property",color:"brown",price:60,rent:[2,10,30,90,160,250],housePrice:50,mortgage:30},
  {id:2,name:"Community Chest",type:"community"},
  {id:3,name:"Baltic Ave",type:"property",color:"brown",price:60,rent:[4,20,60,180,320,450],housePrice:50,mortgage:30},
  {id:4,name:"Income Tax",type:"tax",amount:200},
  {id:5,name:"Reading Railroad",type:"railroad",price:200,mortgage:100},
  {id:6,name:"Oriental Ave",type:"property",color:"lightblue",price:100,rent:[6,30,90,270,400,550],housePrice:50,mortgage:50},
  {id:7,name:"Chance",type:"chance"},
  {id:8,name:"Vermont Ave",type:"property",color:"lightblue",price:100,rent:[6,30,90,270,400,550],housePrice:50,mortgage:50},
  {id:9,name:"Connecticut Ave",type:"property",color:"lightblue",price:120,rent:[8,40,100,300,450,600],housePrice:50,mortgage:60},
  {id:10,name:"Jail / Just Visiting",type:"jail"},
  {id:11,name:"St. Charles Place",type:"property",color:"pink",price:140,rent:[10,50,150,450,625,750],housePrice:100,mortgage:70},
  {id:12,name:"Electric Company",type:"utility",price:150,mortgage:75},
  {id:13,name:"States Ave",type:"property",color:"pink",price:140,rent:[10,50,150,450,625,750],housePrice:100,mortgage:70},
  {id:14,name:"Virginia Ave",type:"property",color:"pink",price:160,rent:[12,60,180,500,700,900],housePrice:100,mortgage:80},
  {id:15,name:"Pennsylvania Railroad",type:"railroad",price:200,mortgage:100},
  {id:16,name:"St. James Place",type:"property",color:"orange",price:180,rent:[14,70,200,550,750,950],housePrice:100,mortgage:90},
  {id:17,name:"Community Chest",type:"community"},
  {id:18,name:"Tennessee Ave",type:"property",color:"orange",price:180,rent:[14,70,200,550,750,950],housePrice:100,mortgage:90},
  {id:19,name:"New York Ave",type:"property",color:"orange",price:200,rent:[16,80,220,600,800,1000],housePrice:100,mortgage:100},
  {id:20,name:"Free Parking",type:"freeparking"},
  {id:21,name:"Kentucky Ave",type:"property",color:"red",price:220,rent:[18,90,250,700,875,1050],housePrice:150,mortgage:110},
  {id:22,name:"Chance",type:"chance"},
  {id:23,name:"Indiana Ave",type:"property",color:"red",price:220,rent:[18,90,250,700,875,1050],housePrice:150,mortgage:110},
  {id:24,name:"Illinois Ave",type:"property",color:"red",price:240,rent:[20,100,300,750,925,1100],housePrice:150,mortgage:120},
  {id:25,name:"B&O Railroad",type:"railroad",price:200,mortgage:100},
  {id:26,name:"Atlantic Ave",type:"property",color:"yellow",price:260,rent:[22,110,330,800,975,1150],housePrice:150,mortgage:130},
  {id:27,name:"Ventnor Ave",type:"property",color:"yellow",price:260,rent:[22,110,330,800,975,1150],housePrice:150,mortgage:130},
  {id:28,name:"Water Works",type:"utility",price:150,mortgage:75},
  {id:29,name:"Marvin Gardens",type:"property",color:"yellow",price:280,rent:[24,120,360,850,1025,1200],housePrice:150,mortgage:140},
  {id:30,name:"Go To Jail",type:"gotojail"},
  {id:31,name:"Pacific Ave",type:"property",color:"green",price:300,rent:[26,130,390,900,1100,1275],housePrice:200,mortgage:150},
  {id:32,name:"North Carolina Ave",type:"property",color:"green",price:300,rent:[26,130,390,900,1100,1275],housePrice:200,mortgage:150},
  {id:33,name:"Community Chest",type:"community"},
  {id:34,name:"Pennsylvania Ave",type:"property",color:"green",price:320,rent:[28,150,450,1000,1200,1400],housePrice:200,mortgage:160},
  {id:35,name:"Short Line Railroad",type:"railroad",price:200,mortgage:100},
  {id:36,name:"Chance",type:"chance"},
  {id:37,name:"Park Place",type:"property",color:"darkblue",price:350,rent:[35,175,500,1100,1300,1500],housePrice:200,mortgage:175},
  {id:38,name:"Luxury Tax",type:"tax",amount:100},
  {id:39,name:"Boardwalk",type:"property",color:"darkblue",price:400,rent:[50,200,600,1400,1700,2000],housePrice:200,mortgage:200},
];

const CHANCE_CARDS = [
  {text:"Advance to GO. Collect $200.",action:"move",target:0,collect:200},
  {text:"Advance to Illinois Ave.",action:"move",target:24},
  {text:"Advance to St. Charles Place.",action:"move",target:11},
  {text:"Bank pays you dividend of $50.",action:"cash",amount:50},
  {text:"Get out of Jail Free.",action:"jailcard"},
  {text:"Go back 3 spaces.",action:"back",spaces:3},
  {text:"Go directly to Jail.",action:"jail"},
  {text:"Make general repairs — $25/house, $100/hotel.",action:"repairs",house:25,hotel:100},
  {text:"Pay poor tax of $15.",action:"cash",amount:-15},
  {text:"Take a trip to Reading Railroad.",action:"move",target:5},
  {text:"Advance to Boardwalk.",action:"move",target:39},
  {text:"Elected Chairman — pay each player $50.",action:"payall",amount:50},
  {text:"Building loan matures — collect $150.",action:"cash",amount:150},
  {text:"Won a crossword competition. Collect $100.",action:"cash",amount:100},
];

const COMMUNITY_CARDS = [
  {text:"Advance to GO. Collect $200.",action:"move",target:0},
  {text:"Bank error in your favor. Collect $200.",action:"cash",amount:200},
  {text:"Doctor's fees. Pay $50.",action:"cash",amount:-50},
  {text:"From sale of stock you get $50.",action:"cash",amount:50},
  {text:"Get out of Jail Free.",action:"jailcard"},
  {text:"Go directly to Jail.",action:"jail"},
  {text:"Grand Opera Night — collect $50 from every player.",action:"collectall",amount:50},
  {text:"Holiday Fund matures. Collect $100.",action:"cash",amount:100},
  {text:"Income tax refund. Collect $20.",action:"cash",amount:20},
  {text:"It is your birthday. Collect $10 from each player.",action:"collectall",amount:10},
  {text:"Life insurance matures. Collect $100.",action:"cash",amount:100},
  {text:"Pay hospital fees of $100.",action:"cash",amount:-100},
  {text:"Pay school fees of $150.",action:"cash",amount:-150},
  {text:"Receive $25 consultancy fee.",action:"cash",amount:25},
  {text:"Street repairs — $40/house, $115/hotel.",action:"repairs",house:40,hotel:115},
  {text:"Won second prize in beauty contest. Collect $10.",action:"cash",amount:10},
  {text:"You inherit $100.",action:"cash",amount:100},
];

function shuffle(arr){const a=[...arr];for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;}
function generateRoomCode(){const chars="ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";return Array.from({length:4},()=>chars[Math.floor(Math.random()*chars.length)]).join("");}
function getRailroadRent(n){return[25,50,100,200][n-1]||25;}
function getColorGroup(color){return BOARD.filter(s=>s.color===color);}

const inputStyle={width:"100%",padding:"10px 14px",background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:10,color:"#F1F5F9",fontSize:14,fontFamily:"inherit",boxSizing:"border-box"};
const confirmBtn={width:"100%",padding:"12px",borderRadius:10,border:"none",background:"linear-gradient(135deg,#F59E0B,#D97706)",color:"white",fontWeight:700,fontSize:14,cursor:"pointer",fontFamily:"inherit"};
const modalBox={background:"#0F172A",border:"1px solid rgba(255,255,255,0.12)",borderRadius:20,padding:28,width:360,maxWidth:"90vw",boxShadow:"0 40px 80px rgba(0,0,0,0.7)",fontFamily:"'Georgia',serif",color:"#E8E3DC"};

function Overlay({children}){return(<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",backdropFilter:"blur(6px)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000}}>{children}</div>);}

export default function MonopolyApp(){
  const [screen,setScreen]=useState("lobby");
  const [roomCode,setRoomCode]=useState("");
  const [joinCode,setJoinCode]=useState("");
  const [myPlayerId,setMyPlayerId]=useState(null);
  const [gameState,setGameState]=useState(null);
  const [localName,setLocalName]=useState("");
  const [localToken,setLocalToken]=useState("🎩");
  const [modal,setModal]=useState(null);
  const [rolling,setRolling]=useState(false);
  const [dice,setDice]=useState([1,1]);
  const [selectedSpace,setSelectedSpace]=useState(null);
  const [error,setError]=useState("");
  const logRef=useRef(null);

  useEffect(()=>{
    if(!roomCode)return;
    const gameRef=ref(db,`games/${roomCode}`);
    const unsub=onValue(gameRef,(snap)=>{
      const data=snap.val();
      if(data){setGameState(data);if(data.screen)setScreen(data.screen);}
    });
    return()=>unsub();
  },[roomCode]);

  useEffect(()=>{if(logRef.current)logRef.current.scrollTop=logRef.current.scrollHeight;},[gameState?.log]);

  const pushUpdate=async(updates)=>await update(ref(db,`games/${roomCode}`),updates);
  const addLog=async(msg,color="#94A3B8")=>await push(ref(db,`games/${roomCode}/log`),{msg,color,ts:Date.now()});

  const createGame=async()=>{
    if(!localName.trim()){setError("Enter your name first.");return;}
    const code=generateRoomCode();
    const initialState={
      screen:"waiting",roomCode:code,currentPlayer:0,
      players:{p0:{id:"p0",index:0,name:localName.trim(),token:localToken,color:PLAYER_COLORS[0],cash:1500,position:0,inJail:false,jailTurns:0,jailCard:false,bankrupt:false}},
      properties:{},chanceIdx:0,communityIdx:0,
      chanceOrder:shuffle(CHANCE_CARDS.map((_,i)=>i)),
      communityOrder:shuffle(COMMUNITY_CARDS.map((_,i)=>i)),
      rolled:false,doublesCount:0,log:{},
    };
    await set(ref(db,`games/${code}`),initialState);
    setRoomCode(code);setMyPlayerId("p0");setScreen("waiting");setError("");
  };

  const joinGame=async()=>{
    if(!localName.trim()){setError("Enter your name.");return;}
    if(!joinCode.trim()){setError("Enter a room code.");return;}
    const code=joinCode.trim().toUpperCase();
    const snap=await get(ref(db,`games/${code}`));
    if(!snap.exists()){setError("Room not found.");return;}
    const data=snap.val();
    const existing=data.players?Object.keys(data.players):[];
    if(existing.length>=6){setError("Game is full.");return;}
    const idx=existing.length;
    const pid=`p${idx}`;
    const usedTokens=Object.values(data.players||{}).map(p=>p.token);
    const token=usedTokens.includes(localToken)?(TOKENS.find(t=>!usedTokens.includes(t))||localToken):localToken;
    await update(ref(db,`games/${code}/players/${pid}`),{id:pid,index:idx,name:localName.trim(),token,color:PLAYER_COLORS[idx],cash:1500,position:0,inJail:false,jailTurns:0,jailCard:false,bankrupt:false});
    setRoomCode(code);setMyPlayerId(pid);setScreen("waiting");setError("");
  };

  const startGame=async()=>{
    await pushUpdate({screen:"game"});
    await addLog("🎲 Game started! Good luck everyone.","#F59E0B");
  };

  const players=gameState?.players?Object.values(gameState.players).sort((a,b)=>a.index-b.index):[];
  const currentPlayerIndex=gameState?.currentPlayer??0;
  const cp=players[currentPlayerIndex];
  const isMyTurn=cp?.id===myPlayerId;
  const properties=gameState?.properties||{};
  const myPlayer=players.find(p=>p.id===myPlayerId);

  const rollDice=()=>{
    if(!isMyTurn||rolling||gameState?.rolled)return;
    setRolling(true);
    let ticks=0;
    const interval=setInterval(()=>{
      setDice([Math.ceil(Math.random()*6),Math.ceil(Math.random()*6)]);
      ticks++;
      if(ticks>=12){
        clearInterval(interval);
        const d1=Math.ceil(Math.random()*6);
        const d2=Math.ceil(Math.random()*6);
        setDice([d1,d2]);
        setRolling(false);
        processRoll(d1,d2);
      }
    },80);
  };

  const processRoll=async(d1,d2)=>{
    const isDoubles=d1===d2;const total=d1+d2;const player=cp;
    if(player.inJail){await handleJailRoll(d1,d2,player,isDoubles,total);return;}
    let newDoubles=gameState.doublesCount||0;
    if(isDoubles){
      newDoubles+=1;
      if(newDoubles>=3){await addLog(`${player.token} ${player.name} rolled doubles 3x — Jail!`,"#EF4444");await sendToJail(player,player.cash);await pushUpdate({rolled:true,doublesCount:0});return;}
      await addLog(`${player.token} ${player.name} rolled doubles (${d1}+${d2})!`,"#F59E0B");
    }else{newDoubles=0;}
    await pushUpdate({rolled:true,doublesCount:newDoubles});
    await movePlayer(player,total,isDoubles);
  };

  const handleJailRoll=async(d1,d2,player,isDoubles,total)=>{
    if(isDoubles){
      await addLog(`${player.token} ${player.name} rolled doubles — out of Jail!`,"#22C55E");
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{inJail:false,jailTurns:0});
      await pushUpdate({rolled:true});
      await movePlayer({...player,inJail:false,position:10},total,false);
    }else if(player.jailTurns>=2){
      const newCash=player.cash-50;
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{inJail:false,jailTurns:0,cash:newCash});
      await addLog(`${player.token} ${player.name} paid $50 bail.`,"#94A3B8");
      await pushUpdate({rolled:true});
      await movePlayer({...player,inJail:false,position:10,cash:newCash},total,false);
    }else{
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{jailTurns:player.jailTurns+1});
      await addLog(`${player.token} ${player.name} is still in Jail. (Turn ${player.jailTurns+1}/3)`,"#F97316");
      await pushUpdate({rolled:true});
    }
  };

  const movePlayer=async(player,steps,isDoubles)=>{
    const oldPos=player.position;const newPos=(oldPos+steps)%40;
    const passedGo=newPos<oldPos&&oldPos!==0;let cash=player.cash;
    if(passedGo){cash+=200;await addLog(`${player.token} ${player.name} passed GO — collect $200!`,"#22C55E");}
    const space=BOARD[newPos];
    await addLog(`${player.token} ${player.name} moved to ${space.name}.`,player.color);
    await update(ref(db,`games/${roomCode}/players/${player.id}`),{position:newPos,cash});
    setSelectedSpace(newPos);
    await handleLanding({...player,position:newPos,cash},space,isDoubles);
  };

  const handleLanding=async(player,space,isDoubles)=>{
    if(space.type==="go"){
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{cash:player.cash+200});
      await addLog(`${player.token} ${player.name} landed on GO — collect $200!`,"#22C55E");
    }else if(space.type==="tax"){
      setModal({type:"info",title:space.name,message:`Pay $${space.amount} to the bank.`,onConfirm:async()=>{
        await update(ref(db,`games/${roomCode}/players/${player.id}`),{cash:player.cash-space.amount});
        await addLog(`${player.token} ${player.name} paid $${space.amount} tax.`,"#EF4444");
        setModal(null);
      }});
    }else if(space.type==="gotojail"){
      await addLog(`${player.token} ${player.name} — GO TO JAIL!`,"#EF4444");
      await sendToJail(player,player.cash);
    }else if(space.type==="chance"){
      const idx=(gameState.chanceIdx||0)%CHANCE_CARDS.length;
      const cardIdx=(gameState.chanceOrder||[])[idx]??idx;
      await pushUpdate({chanceIdx:idx+1});
      await handleCard(player,CHANCE_CARDS[cardIdx],"Chance");
    }else if(space.type==="community"){
      const idx=(gameState.communityIdx||0)%COMMUNITY_CARDS.length;
      const cardIdx=(gameState.communityOrder||[])[idx]??idx;
      await pushUpdate({communityIdx:idx+1});
      await handleCard(player,COMMUNITY_CARDS[cardIdx],"Community Chest");
    }else if(["property","railroad","utility"].includes(space.type)){
      await handlePropertyLanding(player,space);
    }
  };

  const handleCard=async(player,card,deckName)=>{
    await addLog(`${player.token} ${player.name} drew: "${card.text}"`,"#8B5CF6");
    if(card.action==="cash"){
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{cash:player.cash+card.amount});
      setModal({type:"card",deckName,card,onConfirm:()=>setModal(null)});
    }else if(card.action==="move"){
      setModal({type:"card",deckName,card,onConfirm:async()=>{
        setModal(null);
        const passGo=card.target<player.position;const bonus=passGo?200:0;
        if(passGo)await addLog(`${player.token} ${player.name} passed GO — collect $200!`,"#22C55E");
        await update(ref(db,`games/${roomCode}/players/${player.id}`),{position:card.target,cash:player.cash+bonus});
        setSelectedSpace(card.target);
        await handleLanding({...player,position:card.target,cash:player.cash+bonus},BOARD[card.target],false);
      }});
    }else if(card.action==="jail"){
      setModal({type:"card",deckName,card,onConfirm:async()=>{setModal(null);await sendToJail(player,player.cash);}});
    }else if(card.action==="jailcard"){
      await update(ref(db,`games/${roomCode}/players/${player.id}`),{jailCard:true});
      setModal({type:"card",deckName,card,onConfirm:()=>setModal(null)});
    }else if(card.action==="back"){
      const newPos=(player.position-card.spaces+40)%40;
      setModal({type:"card",deckName,card,onConfirm:async()=>{
        setModal(null);
        await update(ref(db,`games/${roomCode}/players/${player.id}`),{position:newPos});
        setSelectedSpace(newPos);
        await handleLanding({...player,position:newPos},BOARD[newPos],false);
      }});
    }else if(card.action==="payall"){
      const others=players.filter(p=>!p.bankrupt&&p.id!==player.id);
      const total=others.length*card.amount;
      setModal({type:"card",deckName,card,onConfirm:async()=>{
        setModal(null);
        const u={};u[`games/${roomCode}/players/${player.id}/cash`]=player.cash-total;
        others.forEach(p=>{u[`games/${roomCode}/players/${p.id}/cash`]=p.cash+card.amount;});
        await update(ref(db),u);
        await addLog(`${player.token} ${player.name} paid $${card.amount} to each player.`,"#EF4444");
      }});
    }else if(card.action==="collectall"){
      const others=players.filter(p=>!p.bankrupt&&p.id!==player.id);
      const total=others.length*card.amount;
      setModal({type:"card",deckName,card,onConfirm:async()=>{
        setModal(null);
        const u={};u[`games/${roomCode}/players/${player.id}/cash`]=player.cash+total;
        others.forEach(p=>{u[`games/${roomCode}/players/${p.id}/cash`]=p.cash-card.amount;});
        await update(ref(db),u);
        await addLog(`${player.token} ${player.name} collected $${card.amount} from each player.`,"#22C55E");
      }});
    }else if(card.action==="repairs"){
      const owned=Object.entries(properties).filter(([,p])=>p.owner===player.id);
      const houses=owned.reduce((s,[,p])=>s+(!p.hotel?(p.houses||0):0),0);
      const hotels=owned.filter(([,p])=>p.hotel).length;
      const cost=houses*card.house+hotels*card.hotel;
      setModal({type:"card",deckName,card,extra:`${houses} houses + ${hotels} hotels = $${cost}`,onConfirm:async()=>{
        setModal(null);
        await update(ref(db,`games/${roomCode}/players/${player.id}`),{cash:player.cash-cost});
        await addLog(`${player.token} ${player.name} paid $${cost} repairs.`,"#EF4444");
      }});
    }else{setModal({type:"card",deckName,card,onConfirm:()=>setModal(null)});}
  };

  const handlePropertyLanding=async(player,space)=>{
    const prop=properties[space.id];
    if(!prop){
      setModal({type:"buy",space,player,
        onBuy:async()=>{
          await update(ref(db,`games/${roomCode}/properties/${space.id}`),{owner:player.id,houses:0,hotel:false,mortgaged:false});
          await update(ref(db,`games/${roomCode}/players/${player.id}`),{cash:player.cash-space.price});
          await addLog(`${player.token} ${player.name} bought ${space.name} for $${space.price}.`,player.color);
          setModal(null);
        },
        onPass:()=>setModal(null),
      });
    }else if(prop.owner!==player.id&&!prop.mortgaged){
      const owner=players.find(p=>p.id===prop.owner);if(!owner)return;
      let rent=0;
      if(space.type==="railroad"){
        const n=Object.entries(properties).filter(([id,p])=>p.owner===prop.owner&&BOARD[parseInt(id)]?.type==="railroad").length;
        rent=getRailroadRent(n);
      }else if(space.type==="utility"){
        const n=Object.entries(properties).filter(([id,p])=>p.owner===prop.owner&&BOARD[parseInt(id)]?.type==="utility").length;
        rent=(dice[0]+dice[1])*(n===2?10:4);
      }else{
        const group=getColorGroup(space.color);
        const ownsAll=group.every(s=>properties[s.id]?.owner===prop.owner);
        const level=prop.hotel?5:(prop.houses||0);
        rent=ownsAll&&level===0?space.rent[0]*2:space.rent[level];
      }
      setModal({type:"rent",space,player,owner,rent,onConfirm:async()=>{
        const u={};
        u[`games/${roomCode}/players/${player.id}/cash`]=player.cash-rent;
        u[`games/${roomCode}/players/${owner.id}/cash`]=owner.cash+rent;
        await update(ref(db),u);
        await addLog(`${player.token} ${player.name} paid $${rent} rent to ${owner.token} ${owner.name}.`,"#EF4444");
        setModal(null);
      }});
    }else if(prop.owner===player.id){
      await addLog(`${player.token} ${player.name} owns ${space.name}.`,"#64748B");
    }
  };

  const sendToJail=async(player,cash)=>{
    await update(ref(db,`games/${roomCode}/players/${player.id}`),{inJail:true,jailTurns:0,position:10,cash});
    await pushUpdate({doublesCount:0});setSelectedSpace(10);
  };

  const endTurn=async()=>{
    const isDoubles=dice[0]===dice[1]&&!cp?.inJail&&(gameState?.doublesCount||0)>0;
    if(isDoubles){await pushUpdate({rolled:false});await addLog(`${cp.token} ${cp.name} rolls again for doubles!`,"#F59E0B");return;}
    let next=(currentPlayerIndex+1)%players.length;let tries=0;
    while(players[next]?.bankrupt&&tries<players.length){next=(next+1)%players.length;tries++;}
    await pushUpdate({currentPlayer:next,rolled:false,doublesCount:0});
    await addLog(`--- ${players[next]?.token} ${players[next]?.name}'s turn ---`,"#475569");
  };

  const useJailCard=async()=>{
    if(!cp?.jailCard||!cp?.inJail)return;
    await update(ref(db,`games/${roomCode}/players/${cp.id}`),{inJail:false,jailTurns:0,jailCard:false});
    await addLog(`${cp.token} ${cp.name} used Get Out of Jail Free!`,"#22C55E");
  };

  const buyHouse=async(spaceId)=>{
    const space=BOARD[spaceId];const prop=properties[spaceId];
    if(!prop||prop.owner!==myPlayerId||!isMyTurn)return;
    const player=players.find(p=>p.id===myPlayerId);if(!player)return;
    const group=getColorGroup(space.color);
    const ownsAll=group.every(s=>properties[s.id]?.owner===myPlayerId);
    if(!ownsAll||prop.hotel||player.cash<space.housePrice)return;
    if(prop.houses>=4){
      await update(ref(db,`games/${roomCode}/properties/${spaceId}`),{houses:0,hotel:true});
      await update(ref(db,`games/${roomCode}/players/${myPlayerId}`),{cash:player.cash-space.housePrice});
      await addLog(`${player.token} ${player.name} built a 🏨 hotel on ${space.name}.`,player.color);
    }else{
      await update(ref(db,`games/${roomCode}/properties/${spaceId}`),{houses:(prop.houses||0)+1});
      await update(ref(db,`games/${roomCode}/players/${myPlayerId}`),{cash:player.cash-space.housePrice});
      await addLog(`${player.token} ${player.name} built a 🏠 house on ${space.name}.`,player.color);
    }
  };

  const sellHouse=async(spaceId)=>{
    const space=BOARD[spaceId];const prop=properties[spaceId];
    if(!prop||prop.owner!==myPlayerId)return;
    const player=players.find(p=>p.id===myPlayerId);if(!player)return;
    const refund=Math.floor(space.housePrice/2);
    if(prop.hotel){
      await update(ref(db,`games/${roomCode}/properties/${spaceId}`),{hotel:false,houses:4});
      await update(ref(db,`games/${roomCode}/players/${myPlayerId}`),{cash:player.cash+refund});
      await addLog(`${player.token} ${player.name} sold hotel on ${space.name} for $${refund}.`,"#22C55E");
    }else if(prop.houses>0){
      await update(ref(db,`games/${roomCode}/properties/${spaceId}`),{houses:prop.houses-1});
      await update(ref(db,`games/${roomCode}/players/${myPlayerId}`),{cash:player.cash+refund});
      await addLog(`${player.token} ${player.name} sold house on ${space.name} for $${refund}.`,"#22C55E");
    }
  };

  const declareBankrupt=async()=>{
    await update(ref(db,`games/${roomCode}/players/${myPlayerId}`),{bankrupt:true});
    await addLog(`${cp?.token} ${cp?.name} declared bankruptcy! 💀`,"#EF4444");
    await endTurn();
  };

  const logEntries=gameState?.log?Object.values(gameState.log).sort((a,b)=>a.ts-b.ts):[];
  const spaceInfo=selectedSpace!==null?BOARD[selectedSpace]:null;
  const spaceOwned=spaceInfo?properties[spaceInfo.id]:null;
  const spaceOwner=spaceOwned?players.find(p=>p.id===spaceOwned.owner):null;

  // LOBBY
  if(screen==="lobby")return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0A1628,#1a1a2e,#0d1117)",fontFamily:"'Georgia',serif",color:"#E8E3DC",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"40px 20px"}}>
      <div style={{textAlign:"center",marginBottom:48}}>
        <div style={{fontSize:11,letterSpacing:6,color:"#F59E0B",textTransform:"uppercase",marginBottom:12}}>Online Multiplayer</div>
        <h1 style={{fontSize:"clamp(40px,7vw,80px)",margin:0,fontWeight:400,letterSpacing:"-2px"}}>Monopoly</h1>
        <p style={{color:"#64748B",marginTop:12,fontSize:14}}>Play with friends across any device</p>
      </div>
      <div style={{width:"100%",maxWidth:420}}>
        <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:16,padding:20,marginBottom:16}}>
          <div style={{fontSize:10,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:10}}>Your Info</div>
          <input placeholder="Your name" value={localName} onChange={e=>setLocalName(e.target.value)} style={inputStyle}/>
          <div style={{marginTop:12,fontSize:11,color:"#475569",letterSpacing:2,marginBottom:8}}>PICK A TOKEN</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {TOKENS.map(t=>(
              <button key={t} onClick={()=>setLocalToken(t)} style={{width:40,height:40,borderRadius:8,fontSize:20,border:localToken===t?"2px solid #F59E0B":"1px solid rgba(255,255,255,0.1)",background:localToken===t?"rgba(245,158,11,0.15)":"rgba(255,255,255,0.04)",cursor:"pointer"}}>{t}</button>
            ))}
          </div>
        </div>
        {error&&<div style={{color:"#EF4444",fontSize:13,marginBottom:12,textAlign:"center"}}>{error}</div>}
        <button onClick={createGame} style={{width:"100%",padding:"16px",borderRadius:14,border:"none",background:"linear-gradient(135deg,#F59E0B,#D97706)",color:"white",fontSize:16,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginBottom:12,letterSpacing:1}}>🏠 Create New Game</button>
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
          <div style={{flex:1,height:1,background:"rgba(255,255,255,0.08)"}}/>
          <span style={{fontSize:12,color:"#475569"}}>or join existing</span>
          <div style={{flex:1,height:1,background:"rgba(255,255,255,0.08)"}}/>
        </div>
        <div style={{display:"flex",gap:8}}>
          <input placeholder="Room code" value={joinCode} onChange={e=>setJoinCode(e.target.value.toUpperCase())} style={{...inputStyle,flex:1,letterSpacing:4,textAlign:"center"}}/>
          <button onClick={joinGame} style={{padding:"0 20px",borderRadius:12,border:"1px solid rgba(255,255,255,0.15)",background:"rgba(255,255,255,0.06)",color:"#E8E3DC",cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Join</button>
        </div>
      </div>
    </div>
  );

  // WAITING ROOM
  if(screen==="waiting")return(
    <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0A1628,#1a1a2e)",fontFamily:"'Georgia',serif",color:"#E8E3DC",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"40px 20px"}}>
      <div style={{textAlign:"center",marginBottom:40}}>
        <div style={{fontSize:11,letterSpacing:6,color:"#F59E0B",textTransform:"uppercase",marginBottom:12}}>Waiting Room</div>
        <h2 style={{fontSize:48,margin:0,fontWeight:400,letterSpacing:-2}}>Monopoly</h2>
      </div>
      <div style={{background:"rgba(245,158,11,0.1)",border:"2px solid #F59E0B44",borderRadius:16,padding:"20px 40px",marginBottom:32,textAlign:"center"}}>
        <div style={{fontSize:11,letterSpacing:4,color:"#F59E0B",marginBottom:8}}>ROOM CODE</div>
        <div style={{fontSize:56,fontWeight:700,letterSpacing:12,color:"#FCD34D"}}>{roomCode}</div>
        <div style={{fontSize:13,color:"#64748B",marginTop:8}}>Share this code with friends to join</div>
      </div>
      <div style={{width:"100%",maxWidth:420,marginBottom:24}}>
        <div style={{fontSize:11,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:12}}>Players ({players.length}/6)</div>
        {players.map(p=>(
          <div key={p.id} style={{display:"flex",alignItems:"center",gap:14,padding:"12px 16px",borderRadius:12,marginBottom:8,background:"rgba(255,255,255,0.04)",border:p.id===myPlayerId?"1px solid rgba(245,158,11,0.3)":"1px solid rgba(255,255,255,0.06)"}}>
            <div style={{width:40,height:40,borderRadius:"50%",background:p.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>{p.token}</div>
            <div>
              <div style={{fontWeight:700}}>{p.name}</div>
              <div style={{fontSize:11,color:"#64748B"}}>{p.id==="p0"?"Host":"Player"}{p.id===myPlayerId?" · You":""}</div>
            </div>
          </div>
        ))}
      </div>
      {myPlayerId==="p0"?(
        <button onClick={startGame} disabled={players.length<2} style={{padding:"16px 48px",borderRadius:14,border:"none",background:players.length>=2?"linear-gradient(135deg,#22C55E,#16A34A)":"rgba(255,255,255,0.05)",color:"white",fontSize:16,fontWeight:700,cursor:players.length>=2?"pointer":"not-allowed",fontFamily:"inherit",opacity:players.length<2?0.5:1}}>
          {players.length<2?"Waiting for players...":"Start Game 🎲"}
        </button>
      ):(
        <div style={{fontSize:14,color:"#64748B"}}>Waiting for the host to start...</div>
      )}
    </div>
  );

  // GAME SCREEN
  return(
    <div style={{minHeight:"100vh",background:"#0A0F1E",fontFamily:"'Georgia',serif",color:"#E8E3DC"}}>
      {/* TOP BAR */}
      <div style={{background:"rgba(255,255,255,0.03)",borderBottom:"1px solid rgba(255,255,255,0.08)",padding:"10px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:18,fontWeight:400,letterSpacing:-1}}>Monopoly</div>
          <div style={{fontSize:11,letterSpacing:3,color:"#F59E0B",background:"rgba(245,158,11,0.1)",padding:"2px 10px",borderRadius:6}}>{roomCode}</div>
          {myPlayer&&<div style={{fontSize:12,color:"#475569"}}>You: {myPlayer.token} {myPlayer.name}</div>}
        </div>
        <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
          {players.filter(p=>!p.bankrupt).map(p=>(
            <div key={p.id} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 12px",borderRadius:10,background:p.index===currentPlayerIndex?`${p.color}22`:"transparent",border:p.index===currentPlayerIndex?`1px solid ${p.color}55`:"1px solid transparent"}}>
              <span style={{fontSize:16}}>{p.token}</span>
              <div>
                <div style={{fontSize:12,fontWeight:700,color:p.index===currentPlayerIndex?p.color:"#94A3B8"}}>{p.name}{p.id===myPlayerId?" (you)":""}</div>
                <div style={{fontSize:11,color:"#22C55E"}}>${p.cash.toLocaleString()}</div>
              </div>
              {p.inJail&&<span>🔒</span>}
            </div>
          ))}
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"280px 1fr 280px",height:"calc(100vh - 57px)"}}>
        {/* LEFT */}
        <div style={{borderRight:"1px solid rgba(255,255,255,0.06)",padding:16,overflowY:"auto",display:"flex",flexDirection:"column",gap:14}}>
          {cp&&(
            <div style={{background:`${cp.color}11`,border:`1px solid ${cp.color}33`,borderRadius:14,padding:14}}>
              <div style={{fontSize:10,letterSpacing:3,color:cp.color,textTransform:"uppercase",marginBottom:8}}>{isMyTurn?"Your Turn!":cp.name+"'s Turn"}</div>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                <div style={{width:44,height:44,borderRadius:"50%",background:cp.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>{cp.token}</div>
                <div><div style={{fontSize:18,fontWeight:700}}>{cp.name}</div><div style={{fontSize:13,color:"#22C55E"}}>${cp.cash.toLocaleString()}</div></div>
              </div>
              <div style={{fontSize:12,color:"#64748B"}}>📍 {BOARD[cp.position]?.name}</div>
              {cp.inJail&&<div style={{fontSize:12,color:"#F97316",marginTop:4}}>🔒 In Jail (Turn {cp.jailTurns+1}/3)</div>}
              {cp.jailCard&&<div style={{fontSize:12,color:"#22C55E",marginTop:4}}>🃏 Has Jail Free Card</div>}
            </div>
          )}
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:14,textAlign:"center"}}>
            <div style={{display:"flex",justifyContent:"center",gap:14,marginBottom:14}}>
              {dice.map((d,i)=>(
                <div key={i} style={{width:58,height:58,background:"white",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:30,color:"#111",boxShadow:"0 4px 20px rgba(0,0,0,0.5)"}}>
                  {["","⚀","⚁","⚂","⚃","⚄","⚅"][d]}
                </div>
              ))}
            </div>
            {gameState?.rolled&&<div style={{fontSize:13,color:"#F59E0B",marginBottom:10}}>Total: {dice[0]+dice[1]}{dice[0]===dice[1]?" — Doubles! 🎉":""}</div>}
            {!isMyTurn?(
              <div style={{fontSize:13,color:"#475569",padding:"10px 0"}}>Waiting for {cp?.name}...</div>
            ):(
              <>
                <button onClick={rollDice} disabled={rolling||gameState?.rolled} style={{width:"100%",padding:"12px",borderRadius:10,border:"none",background:(!rolling&&!gameState?.rolled)?"linear-gradient(135deg,#F59E0B,#D97706)":"rgba(255,255,255,0.06)",color:"white",fontSize:14,fontWeight:700,cursor:(!rolling&&!gameState?.rolled)?"pointer":"not-allowed",fontFamily:"inherit",opacity:(!rolling&&!gameState?.rolled)?1:0.5,marginBottom:8}}>
                  {rolling?"Rolling...":gameState?.rolled?"Rolled ✓":"🎲 Roll Dice"}
                </button>
                {cp?.inJail&&cp?.jailCard&&(
                  <button onClick={useJailCard} style={{width:"100%",padding:"10px",borderRadius:10,border:"1px solid #22C55E44",background:"rgba(34,197,94,0.1)",color:"#4ADE80",fontSize:12,cursor:"pointer",fontFamily:"inherit",marginBottom:8}}>🃏 Use Jail Free Card</button>
                )}
                <button onClick={endTurn} disabled={!gameState?.rolled} style={{width:"100%",padding:"12px",borderRadius:10,border:"1px solid rgba(255,255,255,0.15)",background:gameState?.rolled?"rgba(255,255,255,0.08)":"transparent",color:gameState?.rolled?"#E8E3DC":"#334155",fontSize:14,cursor:gameState?.rolled?"pointer":"not-allowed",fontFamily:"inherit"}}>⏭️ End Turn</button>
                <button onClick={declareBankrupt} style={{width:"100%",padding:"8px",borderRadius:10,marginTop:8,border:"1px solid #EF444433",background:"rgba(239,68,68,0.08)",color:"#EF4444",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>💀 Declare Bankrupt</button>
              </>
            )}
          </div>
          {myPlayer&&(
            <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:14}}>
              <div style={{fontSize:10,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:10}}>My Properties</div>
              {Object.entries(properties).filter(([,p])=>p.owner===myPlayerId).length===0
                ?<div style={{fontSize:12,color:"#334155"}}>None yet</div>
                :Object.entries(properties).filter(([,p])=>p.owner===myPlayerId).map(([id,prop])=>{
                    const space=BOARD[parseInt(id)];
                    const group=space.color?getColorGroup(space.color):[];
                    const ownsAll=group.length>0&&group.every(s=>properties[s.id]?.owner===myPlayerId);
                    return(
                      <div key={id} onClick={()=>setSelectedSpace(parseInt(id))} style={{padding:"6px 8px",borderRadius:6,marginBottom:4,cursor:"pointer",borderLeft:`3px solid ${space.color?COLORS[space.color]:"#607D8B"}`,background:selectedSpace===parseInt(id)?"rgba(255,255,255,0.06)":"transparent"}}>
                        <div style={{fontSize:11,color:"#94A3B8"}}>{space.name}</div>
                        <div style={{fontSize:10,color:"#475569"}}>{prop.hotel?"🏨":"🏠".repeat(prop.houses||0)}{ownsAll&&isMyTurn&&!prop.hotel&&<span style={{color:"#22C55E",marginLeft:4}}>· Build</span>}</div>
                      </div>
                    );
                  })
              }
            </div>
          )}
        </div>

        {/* CENTER */}
        <div style={{overflowY:"auto",padding:16,display:"flex",flexDirection:"column",gap:16}}>
          <div style={{background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)",borderRadius:14,padding:14}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:10}}>Board — Click any space for details</div>
            <BoardGrid players={players} properties={properties} selectedSpace={selectedSpace} onSelect={setSelectedSpace} currentPlayerIndex={currentPlayerIndex}/>
          </div>
          {spaceInfo&&(
            <SpaceDetail space={spaceInfo} prop={spaceOwned} owner={spaceOwner} players={players} myPlayerId={myPlayerId} isMyTurn={isMyTurn} properties={properties} onBuyHouse={()=>buyHouse(spaceInfo.id)} onSellHouse={()=>sellHouse(spaceInfo.id)}/>
          )}
        </div>

        {/* RIGHT */}
        <div style={{borderLeft:"1px solid rgba(255,255,255,0.06)",padding:16,overflowY:"auto",display:"flex",flexDirection:"column",gap:14}}>
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:14}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:10}}>All Properties</div>
            {players.filter(p=>!p.bankrupt).map(p=>{
              const owned=Object.entries(properties).filter(([,pr])=>pr.owner===p.id);
              if(!owned.length)return null;
              return(
                <div key={p.id} style={{marginBottom:10}}>
                  <div style={{fontSize:11,fontWeight:700,color:p.color,marginBottom:4}}>{p.token} {p.name}</div>
                  {owned.map(([id,pr])=>{
                    const space=BOARD[parseInt(id)];
                    return(
                      <div key={id} onClick={()=>setSelectedSpace(parseInt(id))} style={{display:"flex",justifyContent:"space-between",padding:"3px 8px",borderRadius:5,marginBottom:2,cursor:"pointer",borderLeft:`3px solid ${space.color?COLORS[space.color]:"#607D8B"}`,background:selectedSpace===parseInt(id)?"rgba(255,255,255,0.06)":"transparent"}}>
                        <span style={{fontSize:11,color:"#94A3B8"}}>{space.name}</span>
                        <span style={{fontSize:11}}>{pr.hotel?"🏨":"🏠".repeat(pr.houses||0)}</span>
                      </div>
                    );
                  })}
                </div>
              );
            })}
            {Object.keys(properties).length===0&&<div style={{fontSize:12,color:"#334155"}}>No properties yet.</div>}
          </div>
          <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:14,flex:1}}>
            <div style={{fontSize:10,letterSpacing:3,color:"#475569",textTransform:"uppercase",marginBottom:10}}>Game Log</div>
            <div ref={logRef} style={{maxHeight:400,overflowY:"auto",display:"flex",flexDirection:"column",gap:4}}>
              {logEntries.map((entry,i)=>(
                <div key={i} style={{fontSize:11,color:entry.color,lineHeight:1.5}}>{entry.msg}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {modal&&<Modal modal={modal} players={players} onClose={()=>setModal(null)}/>}
    </div>
  );
}

function BoardGrid({players,properties,selectedSpace,onSelect,currentPlayerIndex}){
  const SIZE=11;const cellSize=42;
  const posToGrid=(pos)=>{
    if(pos<=10)return{row:10,col:10-pos};
    if(pos<=20)return{row:10-(pos-10),col:0};
    if(pos<=30)return{row:0,col:pos-20};
    return{row:pos-30,col:10};
  };
  return(
    <div style={{display:"grid",gridTemplateColumns:`repeat(${SIZE},${cellSize}px)`,gridTemplateRows:`repeat(${SIZE},${cellSize}px)`,gap:2,justifyContent:"center"}}>
      {Array.from({length:SIZE*SIZE}).map((_,idx)=>{
        const row=Math.floor(idx/SIZE);const col=idx%SIZE;
        let boardPos=null;
        for(let i=0;i<40;i++){const g=posToGrid(i);if(g.row===row&&g.col===col){boardPos=i;break;}}
        const isCenter=row>0&&row<10&&col>0&&col<10;
        if(isCenter&&boardPos===null){
          if(row===5&&col===5)return(<div key={idx} style={{gridColumn:"2 / 11",gridRow:"2 / 11",display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(34,139,34,0.08)",borderRadius:4}}><span style={{fontSize:22,letterSpacing:-1,color:"#1a5c1a"}}>MONOPOLY</span></div>);
          return null;
        }
        if(boardPos===null)return<div key={idx}/>;
        const space=BOARD[boardPos];const prop=properties[boardPos];
        const playersHere=players.filter(p=>p.position===boardPos&&!p.bankrupt);
        const isSelected=selectedSpace===boardPos;
        let bgColor="rgba(255,255,255,0.04)";
        if(space.color)bgColor=COLORS[space.color]+"33";
        else if(space.type==="go")bgColor="rgba(255,100,0,0.2)";
        else if(space.type==="jail")bgColor="rgba(100,100,100,0.2)";
        else if(space.type==="freeparking")bgColor="rgba(255,200,0,0.1)";
        else if(space.type==="gotojail")bgColor="rgba(255,0,0,0.2)";
        else if(space.type==="chance")bgColor="rgba(255,150,0,0.15)";
        else if(space.type==="community")bgColor="rgba(100,150,255,0.15)";
        else if(space.type==="tax")bgColor="rgba(200,50,50,0.2)";
        else if(space.type==="railroad")bgColor="rgba(50,50,50,0.5)";
        else if(space.type==="utility")bgColor="rgba(100,120,130,0.3)";
        return(
          <div key={idx} onClick={()=>onSelect(boardPos)} title={space.name} style={{background:bgColor,border:isSelected?"2px solid #F59E0B":"1px solid rgba(255,255,255,0.08)",borderRadius:4,cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",position:"relative",overflow:"hidden"}}>
            {space.color&&<div style={{position:"absolute",top:0,left:0,right:0,height:4,background:COLORS[space.color]}}/>}
            <div style={{display:"flex",flexWrap:"wrap",gap:1,justifyContent:"center"}}>
              {playersHere.map(p=>(<span key={p.id} style={{fontSize:p.index===currentPlayerIndex?15:12}}>{p.token}</span>))}
            </div>
            {prop&&<div style={{fontSize:8}}>{prop.hotel?"🏨":"🏠".repeat(prop.houses||0)}</div>}
            {prop?.owner!==undefined&&<div style={{position:"absolute",bottom:2,right:2,width:5,height:5,borderRadius:"50%",background:players.find(p=>p.id===prop.owner)?.color||"#fff"}}/>}
          </div>
        );
      })}
    </div>
  );
}

function SpaceDetail({space,prop,owner,players,myPlayerId,isMyTurn,properties,onBuyHouse,onSellHouse}){
  const isOwner=prop?.owner===myPlayerId;
  const colorGroup=space.color?getColorGroup(space.color):[];
  const ownsAll=colorGroup.length>0&&colorGroup.every(s=>properties[s.id]?.owner===prop?.owner);
  return(
    <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:14,padding:18}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
        {space.color&&<div style={{width:12,height:36,borderRadius:3,background:COLORS[space.color],flexShrink:0}}/>}
        <div>
          <div style={{fontSize:16,fontWeight:700}}>{space.name}</div>
          <div style={{fontSize:12,color:"#64748B"}}>{space.type}{space.price?` · $${space.price}`:""}</div>
        </div>
        {owner&&<div style={{marginLeft:"auto",textAlign:"right"}}><div style={{fontSize:11,color:"#475569"}}>Owned by</div><div style={{fontSize:13,color:owner.color,fontWeight:700}}>{owner.token} {owner.name}</div></div>}
      </div>
      {space.type==="property"&&space.rent&&(
        <div style={{marginBottom:12}}>
          {["Site only","1 house","2 houses","3 houses","4 houses","Hotel"].map((label,i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"3px 0",borderBottom:"1px solid rgba(255,255,255,0.04)",fontSize:12,background:(prop?.hotel&&i===5)||(!prop?.hotel&&(prop?.houses||0)===i)?"rgba(255,200,0,0.06)":"transparent"}}>
              <span style={{color:"#64748B"}}>{label}{i===0&&ownsAll?" (×2)":""}</span>
              <span>${i===0&&ownsAll?space.rent[0]*2:space.rent[i]}</span>
            </div>
          ))}
          <div style={{display:"flex",justifyContent:"space-between",padding:"3px 0",fontSize:12}}><span style={{color:"#64748B"}}>House cost</span><span>${space.housePrice}</span></div>
        </div>
      )}
      {space.type==="railroad"&&(
        <div style={{marginBottom:12}}>
          {["1 railroad: $25","2 railroads: $50","3 railroads: $100","4 railroads: $200"].map((t,i)=>(<div key={i} style={{fontSize:12,color:"#64748B",padding:"2px 0"}}>{t}</div>))}
        </div>
      )}
      {isOwner&&isMyTurn&&space.type==="property"&&ownsAll&&(
        <div style={{display:"flex",gap:8,marginTop:8}}>
          <button onClick={onBuyHouse} style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid #22C55E44",background:"rgba(34,197,94,0.1)",color:"#4ADE80",cursor:"pointer",fontSize:12,fontFamily:"'Georgia',serif"}}>🏠 Build {prop?.houses>=4?`Hotel ($${space.housePrice})`:`House ($${space.housePrice})`}</button>
          {(prop?.houses>0||prop?.hotel)&&<button onClick={onSellHouse} style={{flex:1,padding:"10px",borderRadius:10,border:"1px solid #EF444433",background:"rgba(239,68,68,0.1)",color:"#FCA5A5",cursor:"pointer",fontSize:12,fontFamily:"'Georgia',serif"}}>Sell (${Math.floor(space.housePrice/2)})</button>}
        </div>
      )}
      {isOwner&&space.type==="property"&&!ownsAll&&<div style={{fontSize:12,color:"#475569",padding:"8px",background:"rgba(255,255,255,0.03)",borderRadius:8}}>Own the full {space.color} color group to build houses.</div>}
    </div>
  );
}

function Modal({modal,players}){
  if(modal.type==="buy"){
    const{space,player,onBuy,onPass}=modal;
    return(<Overlay><div style={modalBox}>
      <div style={{fontSize:11,letterSpacing:3,color:"#F59E0B",marginBottom:4}}>PROPERTY FOR SALE</div>
      <div style={{fontSize:24,fontWeight:700,marginBottom:4}}>{space.name}</div>
      <div style={{fontSize:14,color:"#64748B",marginBottom:8}}>Price: ${space.price}</div>
      {space.rent&&<div style={{fontSize:13,color:"#94A3B8",marginBottom:8}}>Base rent: ${space.rent[0]}</div>}
      <div style={{fontSize:13,color:"#22C55E",marginBottom:20}}>{player.name}'s cash: ${player.cash.toLocaleString()}</div>
      <div style={{display:"flex",gap:10}}>
        <button onClick={onBuy} disabled={player.cash<space.price} style={{flex:1,padding:"12px",borderRadius:10,border:"none",background:player.cash>=space.price?"linear-gradient(135deg,#22C55E,#16A34A)":"rgba(255,255,255,0.05)",color:"white",fontWeight:700,cursor:player.cash>=space.price?"pointer":"not-allowed",fontSize:14,fontFamily:"inherit",opacity:player.cash<space.price?0.4:1}}>Buy — ${space.price}</button>
        <button onClick={onPass} style={{flex:1,padding:"12px",borderRadius:10,border:"1px solid rgba(255,255,255,0.12)",background:"transparent",color:"#94A3B8",cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Pass</button>
      </div>
    </div></Overlay>);
  }
  if(modal.type==="rent"){
    const{space,player,owner,rent,onConfirm}=modal;
    return(<Overlay><div style={modalBox}>
      <div style={{fontSize:11,letterSpacing:3,color:"#EF4444",marginBottom:4}}>RENT DUE</div>
      <div style={{fontSize:24,fontWeight:700,marginBottom:4}}>{space.name}</div>
      <div style={{fontSize:14,color:"#64748B",marginBottom:12}}>Owned by {owner.token} {owner.name}</div>
      <div style={{fontSize:40,fontWeight:700,color:"#EF4444",marginBottom:8}}>${rent}</div>
      <div style={{fontSize:13,color:"#94A3B8",marginBottom:20}}>{player.name} pays ${rent} to {owner.name}</div>
      <button onClick={onConfirm} style={confirmBtn}>Pay ${rent}</button>
    </div></Overlay>);
  }
  if(modal.type==="card"){
    const{deckName,card,extra,onConfirm}=modal;
    return(<Overlay><div style={modalBox}>
      <div style={{fontSize:11,letterSpacing:3,color:"#8B5CF6",marginBottom:12}}>{deckName.toUpperCase()}</div>
      <div style={{fontSize:20,fontWeight:400,lineHeight:1.5,marginBottom:14}}>{card.text}</div>
      {extra&&<div style={{fontSize:13,color:"#F59E0B",marginBottom:14}}>{extra}</div>}
      <button onClick={onConfirm} style={confirmBtn}>OK</button>
    </div></Overlay>);
  }
  if(modal.type==="info"){
    const{title,message,onConfirm}=modal;
    return(<Overlay><div style={modalBox}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:10}}>{title}</div>
      <div style={{fontSize:14,color:"#94A3B8",marginBottom:20}}>{message}</div>
      <button onClick={onConfirm} style={confirmBtn}>OK</button>
    </div></Overlay>);
  }
  return null;
}
